import React, { useState } from "react";
import styled from "styled-components";
import BigView from "./bannarItems/BigView";
import ListView from "./bannarItems/ListView";
import { LEFT_TO_RIGHT } from "../state/actions/localization.action";
import withLocalization from "../hoc/withLocalization";
import Data from "../data";

const Banner = props => {
  const { i18n } = props;
  const [active, setActive] = useState(0);

  const handleNext = () => {
    if (active < Data.length - 1) {
      setActive(prev => prev + 1);
    } else {
      setActive(0);
    }
  };

  return (
    <Container i18n={i18n}>
      <BigView next={handleNext} item={Data[active]} />
      <ListView list={Data} active={active} />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: ${props =>
    props.i18n.dir === LEFT_TO_RIGHT ? "row" : "row-reverse"};
`;

export default withLocalization(Banner);
